import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CompletionScreen } from "../../components/kiosk/CompletionScreen";
import { KioskLayout } from "../../components/kiosk/KioskLayout";

export function KioskSuccessPage() {
  const navigate = useNavigate();
  const { kind } = useParams();
  const [countdown, setCountdown] = useState(8);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setCountdown((value) => (value > 1 ? value - 1 : value));
    }, 1000);

    const timeoutId = window.setTimeout(() => {
      navigate("/", { replace: true });
    }, 8000);

    return () => {
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
    };
  }, [navigate]);

  const isCheckin = kind === "checkin";

  return (
    <KioskLayout
      title={isCheckin ? "Ingresso completato" : "Uscita completata"}
      subtitle="Operazione conclusa correttamente."
      showBack={false}
    >
      <CompletionScreen
        title={isCheckin ? "Check-in registrato" : "Check-out registrato"}
        message={
          isCheckin
            ? "Il visitatore è stato registrato correttamente."
            : "La visita è stata chiusa correttamente."
        }
        countdown={countdown}
      />
    </KioskLayout>
  );
}
